<template>
    <model-modal
        :model-class="modelClass"
        content-classes="flex flex-col h-full overflow-y-auto items-center"
        slotContainerClasses="w-full h-full relative"
        @opened="onOpened"
        @resetted="onReset"
        ref="modal"
    >
        <template v-slot:default="slotProps">
            <div class="flex flex-col h-full" v-if="slotProps.model">
                <div class="flex p-8 space-x-4 border-b broder-gray-300">
                    <div @click="updateDoneAt" class="cursor-pointer flex-shrink-0 h-[24px] w-[24px] rounded-full flex items-center justify-center" :class="slotProps.model.done_at ? 'bg-green-500' : 'border border-gray-200'">
                        <i class="text-white far fa-check"></i>
                    </div>
                    <div class="-mt-1">
                        <span class="block text-xl" :class="{'line-through': slotProps.model.done_at}">
                            {{ slotProps.model.title }}
                        </span>
                        <task-due-date :task="slotProps.model" v-if="slotProps.model.due_date" />
                    </div>
                </div>
                <div class="p-8 border-b broder-gray-300">
                    <h2 class="mb-4 text-lg">{{ $t('worksite-phase-task-modal.timetracking_title') }}</h2>
                    <div class="relative py-8 bg-white border border-gray-300 rounded h-[86px]" v-if="activities.loading">
                        <v-spa-loader></v-spa-loader>
                    </div>
                    <div v-else>
                        <div class="flex items-center px-8 space-x-4 bg-white border border-gray-300 rounded" v-if="activities.collection.isEmpty()">
                            <div class="h-[60px] w-[60px]">
                                <lottie json="https://shared-assets.trustup.io/lottie/planning-time-activity.json" container-class-name="lottie-worksite-phase-time-activity-animation-container"></lottie>
                            </div>
                            <div class="py-8 text-sm text-gray-800">
                                {{ $t('worksite-phase-task-modal.timetracking_empty') }}
                            </div>
                        </div>
                        <div
                            class="relative flex flex-col space-y-2"
                            :class="{
                                'max-h-[350px] overflow-y-hidden': moreActivitiesDisplayable && ! activities.displayMore,
                                'pb-[50px]': moreActivitiesDisplayable
                            }"
                            v-else
                        >
                            <time-activity-item
                                v-for="activity in activities.collection.get()"
                                :key="activity.uuid"
                                :activity="activity"
                            ></time-activity-item>
                            <div class="absolute bottom-0 left-0 right-0 flex justify-center" v-if="moreActivitiesDisplayable">
                                <button @click.prevent="activities.displayMore = ! activities.displayMore" :class="{'mb-[20px]':  ! activities.displayMore}" class="relative z-10 flex items-center px-4 py-2 text-sm text-gray-600 bg-white border border-gray-400 rounded-full hover:shadow">
                                    <i class="mr-1 far" :class="activities.displayMore ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
                                    <span>
                                        {{ activities.displayMore ? $t('worksite-phase-task-modal.display_less_time_activities') : $t('worksite-phase-task-modal.display_more_time_activities') }}</span>
                                </button>
                                <div class="absolute bottom-0 left-0 right-0 h-[100px] bg-white-to-transparent" v-if="! activities.displayMore"></div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="flex-1 p-8">
                    <h2 class="mb-4 text-lg">{{ $t('worksite-phase-task-modal.comments_title') }}</h2>
                    <trustup-conversation
                        v-bind="conversationOptions"
                    />
                </div>
            </div>
        </template>
    </model-modal>
</template>

<style>
    .bg-white-to-transparent {
        background: rgb(255,255,255);
        background: linear-gradient(0deg, rgba(255,255,255,1) 0%, rgba(255,255,255,1) 70%, rgba(255,255,255,0) 100%);
    }
</style>

<script>
    import Lottie from '@spa/apps/trustup-pro-base-js/components/Lottie';
    import ModelModal from '@spa/apps/trustup-pro-base-js/components/Model/Modal';
    import WorksitePhaseTrustUpIOTask from '@spa/apps/trustup-pro-worksite-js/models/WorksitePhaseTrustUpIOTask';
    import TrustupConversation from "@deegital/vuejs-trustup-io-messaging";
    import TaskDueDate from '@spa/apps/trustup-pro-base-js/components/TrustUpIO/Task/Item/DueDate.vue';
    import TimeActivityItem from '@spa/apps/trustup-pro-planning-js/components/TimeActivity/Item';

    export default {
        components: {
            ModelModal,
            Lottie,
            TrustupConversation,
            TimeActivityItem,
            TaskDueDate
        },

        data() {
            return {
                modelClass: WorksitePhaseTrustUpIOTask,
                activities: {
                    loading: true,
                    data: [],
                    displayMore: false
                },
            }
        },

        computed: {
            model()
            {
                return this.$refs.modal?.model || null;
            },

            moreActivitiesDisplayable() {
                return this.activities.collection.length > 4;
            },

            conversationOptions() {
                let options = this.model.trustup_io_messaging;
                options['user-id'] = this.$store.state.user.id;
                options['display-style'] = 'comments';
                return options;
            }
        },
        
        methods: {
            onOpened(data)
            {
                this.getActivities();
            },

            onReset()
            {
                this.activities = {
                    loading: true,
                    collection: [],
                    displayMore: false
                };
            },

            async getActivities()
            {
                this.activities.loading = true;

                let {activities} = await window.Worksite.endpoints.trustUpIoTaskTimeActivity.setTask(this.model.uuid).index();
                this.activities.collection = activities;
                
                this.activities.loading = false;
            },
            
            async updateDoneAt()
            {
                this.model.done_at = this.model.done_at ? null : this.$moment().format('YYYY-MM-DD HH:mm:ss');
                await this.model.getEndpoint().update({uuid: this.model.uuid, data: this.model.data()});
            }
        }

    }
</script>